import { LIVUP_GS1_MANUFACTURER_CODE_REGEX } from "../constants/Regexes";

export function isLivupEAN13Barcode(barcode) {
  return !!LIVUP_GS1_MANUFACTURER_CODE_REGEX.exec(barcode);
};
